export default {
  methods: {
    notKurejas() {
      window._VMA.$emit(
        'DATA_ERROR',
        'Peržiūra negalima. Šį pranešimą registrui teikė kitas duomenų teikėjas.'
      )
    },
  },
}
